/**
 * Action Name: md_sync_cars
 */

export function syncCarData() {
	let data = {
		action: 'md_sync_cars',
		security: md_object.nonce
	};

	let processMessage = 'Fahrzeuge werden synchronisiert.';

	jQuery.ajax({
		data: data,
		beforeSend: () => {
			jQuery('#response').html(processMessage);
		},
		success: (response) => {
			jQuery('#response').html(response);
		},
		error: (err) => {
			console.log(err);
		}
	});
}
